@for (iconName of iconNames; track iconName) {
  <div>
    <svg-helper [svgName]="iconName"></svg-helper>
    <span>{{iconName}}</span>
  </div>
}